import React from 'react';

export const IconCheck = ({style}) => {

    return (<svg className="icon-check" style={style || {}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                 viewBox="0 0 16 16">
            <path fillRule="evenodd"
                  d="M12.782 4.721a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 0 1-1.06 0l-2.502-2.5A.75.75 0 0 1 4.28 8.22l1.971 1.97 5.47-5.469a.75.75 0 0 1 1.06 0Z"
                  clipRule="evenodd"/>
        </svg>
    )
}